// ORE Product Page v5 — interactivity + cart
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getProductData() {
    return window.oreProductPage5Data || {};
  }

  function buyNow(button) {
    var data = getProductData();
    var variantId = data.variantId;
    if (!variantId) {
      console.warn('[ore-product-page5] no variantId, redirecting to product url');
      if (data.productUrl) window.location.href = data.productUrl;
      return;
    }

    var originalLabel = button ? button.innerHTML : null;
    if (button) {
      button.disabled = true;
      button.innerHTML = 'PROCESSING…';
    }

    // Empty the cart first so checkout only contains this single item, then add and jump straight to /checkout.
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .catch(function () { /* clear is best-effort */ })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('cart add failed');
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[ore-product-page5] buy now failed', err);
        if (button) {
          button.disabled = false;
          button.innerHTML = originalLabel;
        }
        // Fallback: cart permalink that adds the item and routes to checkout
        window.location.href = '/cart/' + parseInt(variantId, 10) + ':1?return_to=/checkout';
      });
  }

  function smoothAnchor(href) {
    if (!href || href.charAt(0) !== '#') return false;
    var id = href.slice(1);
    if (!id) return false;
    var el = document.getElementById(id);
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    var y = window.pageYOffset + rect.top - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }

  function wireBuyNow() {
    var triggers = document.querySelectorAll('[data-ore-p5-buy]');
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        buyNow(btn);
      });
    });
  }

  function wireSmoothAnchors() {
    document
      .querySelectorAll('.ore-p5 a[href^="#"], .ore-p5 .anchor-tabs a, .ore-p5 .nav a')
      .forEach(function (a) {
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href') || '';
          if (smoothAnchor(href)) e.preventDefault();
        });
      });
  }

  function wireWeekTabs() {
    var btns = document.querySelectorAll('.ore-p5 .week-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.week;
        if (!key) return;
        document.querySelectorAll('.ore-p5 .week-btn').forEach(function (b) { b.classList.remove('active'); });
        document.querySelectorAll('.ore-p5 .week-content').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = document.getElementById(key);
        if (panel) panel.classList.add('active');
      });
    });
  }

  function wireThumbs() {
    var thumbs = document.querySelectorAll('.ore-p5 .thumb');
    var heroImg = document.querySelector('.ore-p5 .hero-img img');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.dataset.full || (t.querySelector('img') && t.querySelector('img').src);
        if (heroImg && src) heroImg.src = src;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  function wireMobileSticky() {
    var heroCta = document.getElementById('oreP5HeroCta');
    var stickyBar = document.querySelector('.ore-p5 .mobile-sticky');
    if (!heroCta || !stickyBar || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    observer.observe(heroCta);
  }

  ready(function () {
    wireBuyNow();
    wireSmoothAnchors();
    wireWeekTabs();
    wireThumbs();
    wireMobileSticky();
  });
})();
